export const IMMATRICULATION_ID: number = 1;
export const factureBasePath = 'factures';
